import permission from "@/middlewares/permission";


function loadView( view ) {
    return () => import(`@/views/admin/applications/${ view }.vue`);
}


const Index = loadView( 'Index' );
const View = loadView( 'View' );
const Edit = loadView( 'Edit' );
const Create = loadView( 'Create' );
const EventCreate = loadView( 'EventCreate' );
const EventEdit = loadView( 'EventEdit' );


const applicationRoutes = [
    {
        path: 'applications',
        name: 'api.application.getList',
        component: Index,
        meta: {
            middleware: permission
        }
    },
    {
        path: 'applications/create',
        name: 'api.application.create',
        component: Create,
        meta: {
            middleware: permission
        }
    },
    {
        path: 'applications/:id',
        name: 'api.application.get',
        component: View,
        meta: {
            middleware: permission
        }
    },
    {
        path: 'applications/:id/edit',
        name: 'api.application.update',
        component: Edit,
        meta: {
            middleware: permission
        }
    },
    {
        path: 'applications/:id/events/create',
        name: 'api.application.profile.createEvent',
        component: EventCreate,
        meta: {
            middleware: permission
        }
    },
    {
        path: 'applications/:id/events/edit',
        name: 'api.application.profile.editEvent',
        component: EventEdit,
        meta: {
            middleware: permission
        }
    },
];

export default applicationRoutes;
